jQuery.noConflict();
(function( $ ) {
  var mediaQueries = {
    xs: 0,
    sm: window.matchMedia('(min-width: 576px)'),
    md: window.matchMedia('(min-width: 768px)'),
    lg: window.matchMedia('(min-width: 992px)'),
    xl: window.matchMedia('(min-width: 1200px)')
  }
  $(document).ready(function(){
    var lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy",
      use_native: true
    });
  
    dsox.Utilities.addGTM($);
    dsox.Utilities.headerHeight($);
    dsox.Utilities.autoplayHeroVideo($);
    dsox.Utilities.toggleMobileNavIcons($);
    dsox.Utilities.toggleMobileHamburgerIcon($);
    dsox.Utilities.addCaretToTransparentButton($);
    dsox.Utilities.anchorTargetOffset($);
    dsox.Utilities.moveLabel($);
    dsox.Utilities.acceptCookieConsent($);
    dsox.Utilities.disableRightClickOnImages($);
    dsox.Utilities.removeNBSP($);
    dsox.Slider.heroSlider($);
    dsox.Slider.contentSlider($);
    dsox.Slider.cardSlider($);
    dsox.Slider.photoSliderv1($);
    dsox.Slider.photoSliderv2($);
    dsox.Slider.textSlider($);
    dsox.Animation.fadeAndScroll($);
    dsox.Search.searchModule($);
    dsox.Accordion.toggleIcon($);
    dsox.RepLocator.findARepForm($);
    dsox.HiddenUTMField.setHiddenUTMFields($);
    dsox.InteractiveGraphic.fadeAndShow($);

    $('img[usemap="#top-image-map"]').rwdImageMaps();
  
    if (lazyLoadInstance) {
      lazyLoadInstance.update();
    }
  })

  $(window).on("load", function(){
      dsox.Tabs.tabWidget($, mediaQueries);
  })

  $(window).smartresize(function() {
      dsox.Utilities.viewportDimensions($);
      dsox.Utilities.headerHeight($);
      dsox.Tabs.tabWidget($, mediaQueries);
  }, 200);
})(jQuery);

